<!-- 自主报考填写个人信息页面 -->
<template>
  <div id="app">
      <van-form
        class="fixedBtn"
        :style="{ overflow: 'auto' }"
        ref="form"
        @submit="owninfonext"
        scroll-to-error
        validate-first
      >
      <van-sticky :offset-top="0">
          <van-steps :active="active" active-icon="success" active-color="#38f">
            <van-step>预约时间</van-step>
            <van-step>个人信息</van-step>
            <van-step>上传文件</van-step>
          </van-steps>
        </van-sticky>
        <h4 class="yuinfo">预约信息</h4>
        <div class="own_contain">
          <!-- 姓名 -->
          <div class="own_name">姓名<span>*</span></div>
          <van-field
            type="text"
            maxlength="50"
            class="input-field"
            v-model="ownnameinput"
            placeholder="请输入姓名"
            :rules="[{ required: true }]"
          />
          <!-- 证件类型 -->
          <div class="own_name">证件类型<span>*</span></div>
          <div class="Select" @click="certificateHandler">
            <!-- TODO -->
            <TestInput
              readonly
              :rtest="certificatetype"
              :placeholder="'请选择证件类型'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="certificateShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="certificateOption"
              @confirm="certificateConfirm"
              class="location-picker"
              cancel-button-text="选择证件类型"
            />
          </van-popup>
          <!-- 证件号码 -->
          <div class="own_name">证件号码<span>*</span></div>
          <van-field
          class="input-field"
          maxlength="18"
          v-model="owndentifyinput"
          placeholder="请输入证件号码"
          @blur="getIdInfo"
            :rules="[
              { required: true },
              {
                validator: owndentifyValidator,
                message: '身份证号码格式错误！',
              },
            ]"
            :disabled="userCarDisalbie"
          />
          <!-- 出生日期 -->
          <div class="own_name">出生日期<span>*</span></div>
          <div class="Select" @click="BirthdateHandler">
            <TestInput
              readonly
              :rtest="BirthdateHint"
              :placeholder="'请选择出生日期'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="BirthdateShow"
          >
            <van-datetime-picker
              v-model="BirthdatecurrentDate"
              type="date"
              title="选择年月日"
              :min-date="BirthdateminDate"
              :max-date="BirthdatemaxDate"
              @confirm="BirthdateConfirm"
              @cancel="BirthdateCancel"
              @change="BirthdateChange"
            />
          </van-popup>
          <!-- 性别 -->
          <div class="own_name">性别<span>*</span></div>
          <van-radio-group v-model="sexcheck" direction="horizontal">
            <van-radio name="男">男</van-radio>
            <van-radio name="女">女</van-radio>
          </van-radio-group>
          <!-- 民族 -->
          <div class="own_name">民族</div>
          <div class="Select" @click="nationHandler">
            <TestInput
              readonly
              :rtest="nationHint"
              :placeholder="'请选择证民族'"
              :rules="[{ required: false }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="nationShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="nationOption"
              @confirm="nationConfirm"
              class="location-picker"
              cancel-button-text="请选择民族"
            />
          </van-popup>
          <!-- 政治面貌 -->
          <div class="own_name">政治面貌</div>
          <div class="Select" @click="politicsstatusHandler">
            <TestInput
              readonly
              :rtest="politicsstatusHint"
              :placeholder="'请选择政治面貌'"
              :rules="[{ required: false }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="politicsstatusShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="politicsstatusOption"
              @confirm="politicsstatusConfirm"
              class="location-picker"
              cancel-button-text="请选择政治面貌"
            />
          </van-popup>
          <!-- 所属群体* -->
          <div class="own_name">所属群体<span>*</span></div>
          <div class="Select" @click="ReferenceGroupHandler">
            <TestInput
              readonly
              :rtest="ReferenceGroupHint"
              :placeholder="'请选择所属群体'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="ReferenceGroupShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="ReferenceGroupOption"
              @confirm="ReferenceGroupConfirm"
              class="location-picker"
              cancel-button-text="请选择所属群体"
            />
          </van-popup>
          <!-- 工作单位* -->
          <div class="own_name">工作单位<span>*</span></div>
          <van-field
            type="text"
            class="input-field"
            v-model="workunit"
            placeholder="请输入工作单位名称"
            :rules="[{ required: true }]"
          />
          <!-- 职业年限* -->
          <div class="own_name">职业年限(年)<span>*</span></div>
          <van-field
            type="number"
            class="input-field"
            v-model="term"
            placeholder="请输入职业年限"
            :rules="[{ required: true }]"
          />
          <!-- 现居地址* -->
          <div class="own_name">现居地址<span>*</span></div>
          <div class="Select" @click="currentaddressHandler">
            <TestInput
              readonly
              :rtest="currentaddressHint"
              :placeholder="'请选择现居地址'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="currentaddressShow"
          >
            <van-area
              title="请选择现居地址"
              :area-list="areaList"
              @confirm="currentaddressConfirm"
              @cancel="currentaddressCancel"
            />
          </van-popup>

          <!-- 邮政编码 -->
          <div class="own_name">邮政编码</div>
          <van-field
            type="number"
            class="input-field"
            v-model="postalcode"
            placeholder="请输入邮政编码"
            :rules="[{ required: false }]"
          />
          <!-- 从事职业 -->
          <div class="own_name">从事职业</div>
          <van-field
            type="text"
            class="input-field"
            v-model="engineer"
            placeholder="请输入从事职业"
            :rules="[{ required: false }]"
          />
          <!-- 参加工作日期 -->
          <div class="own_name">参加工作日期</div>
          <div class="Select" @click="DateofentryHandler">
            <TestInput
              readonly
              :rtest="DateofentryHint"
              :placeholder="'请选择参加工作日期'"
              :rules="[{ required: false }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="DateofentryShow"
          >
            <van-datetime-picker
              v-model="DateofentrycurrentDate"
              type="date"
              title="选择年月日"
              :min-date="DateofentryminDate"
              :max-date="DateofentrymaxDate"
              @confirm="DateofentryConfirm"
              @cancel="DateofentryCancel"
            />
          </van-popup>
          <!-- 身份信息 -->
          <div class="own_name">身份信息</div>
          <van-field
            type="text"
            class="input-field"
            v-model="Identity"
            placeholder="请输入身份信息"
            :rules="[{ required: false }]"
          />
          <!-- 职业 -->
          <div class="own_name">职业<span>*</span></div>
          <div class="Select" @click="professionHandler">
            <TestInput
              readonly
              :rtest="professionHint"
              :placeholder="'请选择职业'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="professionShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="professionOption"
              @confirm="professionConfirm"
              class="location-picker"
              cancel-button-text="请选择职业"
            />
          </van-popup>
          <!-- 鉴定分类 -->
          <div class="own_name">鉴定分类<span>*</span></div>
          <div class="Select" @click="classificationHandler">
            <TestInput
              readonly
              :rtest="classificationHint"
              :placeholder="'请选择鉴定分类'"
              :rules="[{ required: true }]"
            ></TestInput>
          </div>
          <van-popup
            position="bottom"
            round
            :style="{ height: '50%' }"
            v-model="classificationShow"
          >
            <van-picker
              confirm="完成"
              show-toolbar
              :columns="classificationOption"
              @confirm="classificationConfirm"
              class="location-picker"
              cancel-button-text="请选择鉴定分类"
            />
          </van-popup>
          <!--  手机号码-->
          <div class="own_name">手机号码<span>*</span></div>
          <van-field
            class="input-field"
            v-model="owntelinput"
            placeholder="请输入手机号码"
            :rules="[{ required: true }]"
            maxlength="11"
            type="number"
            @input="ontelChange"
          />
          <!-- 验证码 -->
          <div class="own_name">验证码<span>*</span></div>
          <van-field
            maxlength="4"
            type="number"
            class="input-field"
            v-model="owntestinput"
            placeholder="请输入验证码"
            :rules="[{ required: true }]"
            :style="{ margin: '0px 0px 20px 0px' }"
          >
            <template #button>
              <van-button
                :style="{ margin: '0px 10px 0px 0px' }"
                size="small"
                type="info"
                @click="sendcode"
                :disabled="isSmsSend"
                >{{ sendBtnText }}
              </van-button>
            </template>
          </van-field>
        </div>
        <div class="submitBtn">
          <van-button size="large" type="info" native-type="submit"
            >下一步</van-button
          >
        </div>
      </van-form>
    
  </div>
</template>

<script>
import headerBox from "@/components/header.vue";
import ArticleItem from "@/components/article-item/index.vue";
import inputBox from "@/components/input.vue";
import { dateadrees } from "../../api/apitotal.js";
import chooseBox from "@/components/choose";
import TestInput from "@/components/choosec";
//Vant 官方提供了一份默认的省市区数据
import { areaList } from "@vant/area-data";
import datetime from "../../utils/datetime.js";
import { Notify, Dialog  } from "vant";

export default {
  name: "App",
  components: {
    ArticleItem,
    inputBox,
    headerBox,
    chooseBox,
    TestInput,
  },
  data() {
    return {
      active: 1,//步骤条
      sexcheck: '',//性别
      gettime: "", //获取时间
      ownnameinput: "", //名字
      owndentifyinput: "", //证件号码
      owntelinput: "", //手机号
      //验证码的5个
      owntestinput: "", //y验证码
      isSmsSend: false, // 是否已经发送了验证码
      sendBtnText: "获取验证码", // 文本
      timer: null, // 计时器对象
      counter: 60, // 倒数60秒
      workunit: "", //工作单位
      term: "", //职业年限
      postalcode: "", //邮政编码
      engineer: "", //从事职业
      Identity: "", //身份信息
      // 证件类型
      certificateShow: false,
      certificatetype: "",
      certificateOption: [
        "居民身份证",
        "中国人民解放军军官证",
        "澳门特区护照/港澳通行证（港澳居民来往内地通行证)",
        "台湾居民来往大陆通行证",
        "护照(外国人护照、香港特区护照和澳门特区护照)",
        "外国人永久居留证",
        "港澳台居民居住证",
        "香港居民身份证",
        "澳门居民身份证",
        "社会保障卡",
      ],
      // 出生年月日
      BirthdateminDate: new Date(1921, 12, 12),
      BirthdatemaxDate: new Date(),
      BirthdatecurrentDate: new Date(1990, 0, 1),
      BirthdateShow: false,
      BirthdateHint: "",
      //民族
      nationShow: false,
      nationHint: "",
      nationOption: [
        "汉族",
        "壮族",
        "满族",
        "回族",
        "苗族",
        "维吾尔族",
        "彝族",
        "土家族",
        "蒙古族",
        "藏族",
        "布依族",
        "侗族",
        "瑶族",
        "朝鲜族",
        "白族",
        "哈尼族",
        "黎族",
        "哈萨克族",
        "傣族",
        "畲族",
        "傈僳族",
        "仡佬族",
        "拉祜族",
        "东乡族",
        "佤族",
        "水族",
        "纳西族",
        "羌族",
        "土族",
        "锡伯族",
        "仫佬族",
        "柯尔克孜族",
        "达斡尔族",
        "景颇族",
        "撒拉族",
        "布朗族",
        "毛南族",
        "塔吉克族",
        "普米族",
        "阿昌族",
        "怒族",
        "鄂温克族",
        "京族",
        "基诺族",
        "德昂族",
        "乌孜别克族",
        "俄罗斯族",
        "裕固族",
        "保安族",
        "门巴族",
        "鄂伦春族",
        "独龙族",
        "塔塔尔族",
        "赫哲族",
        "高山族",
        "珞巴族",
      ],
      //面貌
      politicsstatusHint: "",
      politicsstatusShow: false,
      politicsstatusOption: [
        "群众",
        "中国共产党党员",
        "中国共青团团员",
        "民主党派人士",
        "无党派民主人士",
      ],
      //群体
      ReferenceGroupShow: false,
      ReferenceGroupHint: "",
      ReferenceGroupOption: [
        "企业职工",
        "院校学生",
        "下岗失业人员",
        "其他人员",
      ],
      //Vant的默认省市区数据,以及现居地址
      areaList,
      arrArea: [], //存放地区数组
      currentaddressHint: "",
      currentaddressShow: false,
      //参加工作时间
      DateofentryminDate: new Date(1921, 12, 1),
      DateofentrymaxDate: new Date(),
      DateofentrycurrentDate: new Date(1990, 0, 1),
      DateofentryShow: false,
      DateofentryHint: "",
      //职业
      professionHint: "",
      professionOption: ["4140202-健康管理师-三级"],
      professionShow: false,
      //鉴定分类
      classificationHint: "",
      classificationOption: ["初次鉴定", "晋级"],
      classificationShow: false,
      a: {},
      userCarDisalbie:false,
    };
  },
  created() {
    // console.log(this.$route.query.ExamOrder);
    // if (this.$route.query.ExamOrder != null) {
    //   this.ownnameinput = this.$route.query.ExamOrder.examName;
    //   this.owntelinput = this.$route.query.ExamOrder.examPhone;
    // }
    // if (this.$route.query.examOrderId) {
    this.fetchSignupDetails(this.$route.query.examOrderId);
    // }
    // if (localStorage.getItem("examOrderId") != null) {
    //   this.fetchSignupDetails(localStorage.getItem("examOrderId"));
    // }
  },
  methods: {
    findUser(){
      this.$http.get(`ExamOrder/findOneUser`).then((res) => {
        console.log(res)
        this.owndentifyinput=res.data.data.userStudent.cardNo;
        if(res.data.data.userStudent.cardNo!=null){
          this.userCarDisalbie=true;
        }
       // this.ownnameinput = res.data.data.userStudent.realName;
        this.owntelinput = res.data.data.userStudent.mobilePhone;
      });
    },
    //  被驳回以后的个人信息页面
    fetchSignupDetails: function (examOrderId) {
      var params = {
        examOrderId: examOrderId,
      };
      return new Promise((resolve) => {
        this.$http.post(`ExamOrder/ExamOrderShowOne`, params).then((res) => {
          if (res.data.success && res.data.data.list.examName != null) {
            this.signupDetails = res.data.data.list;
            this.ownnameinput = this.signupDetails.examName;
            this.active = this.signupDetails.examCardStatus;
            this.owndentifyinput = this.signupDetails.examCard;
            if(this.signupDetails.examCard!=null){
                this.userCarDisalbie=true;
            }
            this.sexcheck = this.signupDetails.examSex;
            this.owntelinput = this.signupDetails.examPhone;
            this.certificatetype = this.signupDetails.examCardStatus; //z证件类型
            this.BirthdateHint = this.signupDetails.birthdate; //出生日期
            this.sexcheck = this.signupDetails.examSex; // 性别
            this.nationHint = this.signupDetails.nation;
            this.politicsstatusHint = this.signupDetails.politicsstatus;
            this.ReferenceGroupHint = this.signupDetails.referenceGroup;
            this.currentaddressHint = this.signupDetails.currentaddress;
            this.term = this.signupDetails.term;
            this.workunit = this.signupDetails.workunit;
            this.postalcode = this.signupDetails.postalcode;
            this.engineer = this.signupDetails.engineer;
            this.DateofentryHint = this.signupDetails.dateofentry;
            this.Identity = this.signupDetails.identity;
            this.professionHint = this.signupDetails.profession;
            this.classificationHint = this.signupDetails.classification;
          }else{
            this.findUser();
          }
        });
      });
    },

    // 倒计时
    countDown() {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后重新发送`;
        this.counter--;
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          this.reset();
        }
      }, 1000);
    },
    //发送验证码
    sendcode() {
      if (!this.owntelinput) {
        Notify("请输入手机号");
        return false;
      }
      if (this.owntelinput.length !== 11) {
        Notify("请输入11位手机号");
        return false;
      }
      this.isSmsSend = true;
      this.countDown();

      const params = {
        mobileNo: this.owntelinput,
        uuid: 1,
      };

      this.$http.get("/auth/sms/send", { params }).then((res) => {
        console.log(res.data);
        if (res.data.success && res.status == "200") {
          if (res.data.success && res.status == "200") {
            this.$message({
              message: "验证码发送成功",
              type: "success",
            });
          }
        }
      });
    },
    //重置
    reset() {
      // 重置按钮可用
      this.isSmsSend = false;
      // 重置文本内容
      this.sendBtnText = "获取验证码";
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer);
        // 重置秒数，防止下次混乱
        this.counter = 60;
        // 计时器对象重置为空
        this.timer = null;
      }
    },
    //手机号改变时触发
    ontelChange() {
      this.reset();
    },
    //获取身份信息，获取生日，获取性别
    getIdInfo() {
      let cardNo = this.owndentifyinput
    var reg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/; //验证身份证号码的正则
    if(reg.test(cardNo)){ // 身份证号码是否合法
        var birthday = "";
        var gender = "";
        if (cardNo.length == 15) {
            var org_birthday = cardNo.substring(6, 12);
            var org_gender = cardNo.substring(14, 15);
            birthday = "19" + org_birthday.substring(0, 2) + "年"
                + org_birthday.substring(2, 4) + "月"
                + org_birthday.substring(4, 6)+ "日";
            gender = org_gender % 2 == 1 ? "男" : "女";
        } else if (cardNo.length == 18) {
            var org_birthday = cardNo.substring(6, 14);
            var org_gender = cardNo.substring(16, 17);
            birthday = org_birthday.substring(0, 4) + "年"
                + org_birthday.substring(4, 6) + "月"
                + org_birthday.substring(6, 8)+ "日";
            gender = org_gender % 2 == 1 ? "男" : "女";
        }
        this.BirthdateHint = birthday
        this.sexcheck = gender
    }else{
        return false;
    }
},

    
    //下一步
    owninfonext() {
      var logdata = {
        examName: this.ownnameinput, //姓名
        examCardStatus: this.certificatetype, //z证件类型
        examCard: this.owndentifyinput, //证件号码
        birthdate: this.BirthdateHint, //出生日期
        examSex: this.sexcheck, // 性别
        nation: this.nationHint, //民族
        politicsstatus: this.politicsstatusHint, // 政治面貌
        referenceGroup: this.ReferenceGroupHint, // 所属群体
        workunit: this.workunit, // 工作单位
        term: this.term, // 职业年限
        currentaddress: this.currentaddressHint, // 现居地址
        postalcode: this.postalcode, // 邮政编码
        engineer: this.engineer, // 从事职业
        dateofentry: this.DateofentryHint, // 参加工作日期
        identity: this.Identity, // 身份信息
        profession: this.professionHint, // 职业
        classification: this.classificationHint, // 鉴定分类
        examPhone: this.owntelinput, //手机号
        examOrderId: this.$route.query.examOrderId,
      };
      var params = {
        uuid: "1",
        mobileNo: this.owntelinput,
        code: this.owntestinput,
      };
      this.$http.post(`/ExamOrder/captchaCheck`, params).then((res) => {
        if (res.data.success) {
          this.$http.post(`/ExamOrder/addExamOrder`, logdata).then((res) => {
            if(res.data.success){
              this.$router.push({
              path: "/upload_filesC",
              query: { examOrderId: res.data.data.examOrderId },
            });
            }else {
              this.$message.error(`${res.data.msg}`)
            } 
          });
        } else {
          Dialog({ 
            title: '提示',
            message: res.data.msg ,
            confirmButtonText: "确认",
            confirmButtonColor: "#54B0FB",
          });
        }
      });
    },
    //证件类型弹框
    certificateHandler() {
      this.certificateShow = true;
    },

    //证件类型赋值
    certificateConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      console.log(value)
      this.addressindex = index;
      this.certificatetype = value;
      this.certificateShow = false;
    },
    //身份证验证正则
    owndentifyValidator(value) {
      if (this.certificatetype !== '居民身份证') {  //除了居民身份证 其它不校验
        return true
      }
      const card15 =
        /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;
      const card18 =
        /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      return card15.test(value) || card18.test(value);
    },
    //年月日弹框
    BirthdateHandler() {
      this.BirthdateShow = true;
    },
    BirthdateConfirm(value, index) {
      // this.gettime = datetime(value);
      this.BirthdateHint = datetime(value);
      this.BirthdateShow = false;
      console.log(111111, this.BirthdateHint);
    },
    BirthdateCancel() {
      this.BirthdateShow = false;
    },
    BirthdateChange(picker, value, index) {
      console.log(picker, value, index);
    },
    //民族弹框
    nationHandler() {
      this.nationShow = true;
    },
    //民族赋值
    nationConfirm(value, index) {
      this.addressindex = index;
      this.nationHint = value;
      this.nationShow = false;
    },
    //政治面貌弹框
    politicsstatusHandler() {
      this.politicsstatusShow = true;
    },
    politicsstatusConfirm(value, index) {
      this.addressindex = index;
      this.politicsstatusHint = value;
      this.politicsstatusShow = false;
    },
    //政治面貌弹框
    ReferenceGroupHandler() {
      this.ReferenceGroupShow = true;
    },
    ReferenceGroupConfirm(value, index) {
      this.addressindex = index;
      console.log(111111, this.addressindex);
      this.ReferenceGroupHint = value;
      this.ReferenceGroupShow = false;
    },
    //现居地址弹框
    currentaddressHandler() {
      this.currentaddressShow = true;
    },
    //现居地址的格式处理
    currentaddressConfirm(value, index) {
      this.arrArea = value;
      var addrInfo = value[0].name + "/" + value[1].name + "/" + value[2].name;
      this.currentaddressHint = addrInfo;
      this.currentaddressShow = false;
    },
    currentaddressCancel() {
      this.currentaddressShow = false;
    },
    //参加工作日期弹框
    DateofentryHandler() {
      this.DateofentryShow = true;
    },
    DateofentryConfirm(value, index) {
      this.DateofentryHint = datetime(value);
      this.DateofentryShow = false;
      console.log(111111, this.DateofentryHint);
    },
    DateofentryCancel(value, index) {
      this.DateofentryHint = datetime(22222, value);
      this.DateofentryShow = false;
      console.log(1111333, this.DateofentryHint);
    },

    //职业
    professionHandler() {
      this.professionShow = true;
    },
    professionConfirm(value, index) {
      this.addressindex = index;
      this.professionHint = value;
      this.professionShow = false;
    },
    //鉴定分类
    classificationHandler() {
      this.classificationShow = true;
    },
    classificationConfirm(value, index) {
      this.addressindex = index;
      this.classificationHint = value;
      this.classificationShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 30px;
  width: 100%;
  height: 100vh;
  .fixedBtn {
    // 为了不覆盖底部按钮
    padding-bottom: 80px;
    .own_contain {
      width: 100%;
      background: white;
      padding: 20px;
      box-sizing: border-box;
    }
    .submitBtn {
      margin: 20px;
      position: fixed;
      width: 710px;
      bottom: 10px;
      height: 90px;
    }
  }
}
.cat-input {
  width: 100%;
  height: @minboxgao;

  margin-top: @padingboxmax;
  line-height: @minboxgao;
}

.yuinfo {
  height: @minboxgao;
  padding: 0 @padingbox;
  line-height: @minboxgao;
  background: @backgroundcolor;
}
.own_test_out {
  position: relative;
}
.gettest {
  position: absolute;
  right: 5px;
}
.own_typee {
  margin-left: @checkleft;
}
.own_sexs {
  margin-left: @checkleft;
}
.own_type,
.own_contain #identify,
.own_contain #identphone,
.own_contain #other,
.own_contain #girt,
.own_contain #boy,
.own_typtel,
.own_sex,
.own_telnum,
.own_test {
  margin-top: @padingbox;
  margin-right: @checkringht;
}
.own_next {
  margin-top: 40px;
  color: white;
  background: #54b0fb;
  border: 0;
  height: @minboxgao;
  line-height: @minboxgao;
  border-radius: @circlemin;
  width: 100%;
}
.input-field {
  border-radius: 8px;
  border: 0.1 solid #dcdcdc;
}
.input-field.van-field {
  padding: 0;
}
.input-field ::v-deep .van-field__body {
  border: 2px solid #dcdcdc;
  box-sizing: border-box;
}
.input-field ::v-deep .van-field__control {
  padding: 16px;
  color: inherit;
}
.error-message {
  padding-top: 12px;
  font-size: 24px;
  color: red;
}
.own_name {
  height: @minboxgao;
  // padding: 0 @padingbox;
  line-height: @minboxgao;
  // background: @backgroundcolor;
  span {
    color: red;
  }
}
.Select {
  width: 100%;
  height: @minboxgao;
  // margin: @padingboxmax 0;
  margin: auto;
  line-height: @minboxgao;

  .field_border {
    // border: 2px solid black;
  }
}
</style>